<template>
  <div>
    <h5 class="text-center">
      {{ computeCaption(fields_en['please_provide_payment_information'], $store.state.lang.value.toLowerCase()) }}
    </h5>
    <br/>
    <div class="row" :class="[generalClass, validatedSectionClass]">
      <!-- Select payment type -->
      <div v-if="$store.state.configs.RESTRICT_INSURANCE_BY_ICD === true && this.$store.state.icdCodes.length === 0"
           class="row">
        <h5 id="icd codes" class="primary-color text-center">
          {{ computeCaption(fields_en['icd_codes_disclaimer'], $store.state.lang.value.toLowerCase()) }}
        </h5>
      </div>
      <BillSelector @validateSection="validateSection"
                    ref="billSelector"
                    :billsArray="this.$store.state.site.bills_array"
                    :restrictInsuranceByIcd="this.$store.state.configs.RESTRICT_INSURANCE_BY_ICD"
                    :icdCodes="this.$store.state.icdCodes"
                    :allowPayment="this.isTrue(this.$store.state.configs.ALLOW_PAYMENT)"/>
    </div>
  </div>
</template>
<script>
import {FormatterUtils} from '../../../../../utils/Formatter'
import {ValidationUtils} from '../../../../../utils/Validation'
import {Input, Autocomplete, RadioButton, RadioGroup, Checkbox} from 'element-ui'
import MultipleInput from './MultipleInput.vue'
import {TranslationsUtils} from '../../../../../utils/Translations'
import {AccessionUtils} from '../../../../../utils/AccessionDetailsProcessing'
import {QuestionUtils} from '../../../../../utils/Questions'
import {SettingsUtils} from '../../../../../utils/SiteConfigurations'
import QuestionsSection from './QuestionsSection'
import BillSelector from '../SubComponents/BillParts/BillSelector'

export default {
  components: {
    BillSelector,
    [Input.name]: Input,
    [Autocomplete.name]: Autocomplete,
    [RadioButton.name]: RadioButton,
    [RadioGroup.name]: RadioGroup,
    [Checkbox.name]: Checkbox,
    MultipleInput,
    QuestionsSection
  },
  mixins: [FormatterUtils, ValidationUtils, TranslationsUtils, AccessionUtils, QuestionUtils, SettingsUtils],
  props: ['triggerWatch'],
  data () {
    return {
      singlePage: this.$store.state.configs.SINGLE_PAGE_ORDERS || '',
      allow_payment: this.isTrue(this.$store.state.configs.ALLOW_PAYMENT),
      generalClass: 'general-inactive-section',
      validatedSectionClass: '',
      validatedSection: false,
      fields_en: {
        please_provide_payment_information: 'Please Provide Payment Information',
        icd_codes_disclaimer: this.$store.state.configs.RESTRICT_INSURANCE_BY_ICD_MESSAGE || ''
      },
      model: {
        social_security_number: '',
        driver_license_number: '',
        primary_insurance: '',
        primary_insurance_name_input: '',
        policy_number: '',
        group_number: '',
        relationship: '',
        insurance_pay: '',
        insured_first_name: '',
        insured_middle_name: '',
        insured_last_name: '',
        insured_date_of_birth: '',
        insured_date_of_birth_pretty: '',
        insured_address_components: {
          name: '',
          original_name: '',
          delivery_line_1: '',
          city_name: '',
          county: '',
          state_abbreviation: '',
          zipcode: '',
          plus4_code: '',
          county_fips: '',
          country: ''
        },
        selectedBill: '',
        insured_gender: '',
        insurance_card_images: [],
        insurance_card_names: [],
        error_uninsured: '',
        note: ''
      }
    }
  },
  methods: {
    updateModel (modelObject) {
      Object.assign(this.model, modelObject)
    },
    validateSection (booleanValue) {
      if (booleanValue) {
        this.validatedSection = true
        this.validatedSectionClass = 'validated-section-class'
        this.generalClass = 'general-inactive-section'
      } else {
        this.validatedSection = false
        this.validatedSectionClass = 'invalid-section-class'
        this.generalClass = 'general-invalid-section'
      }
    },
    async validate () {
      const billModel = await this.$refs.billSelector.validate()
      this.updateModel(billModel)
      if ((await this.$validator.validateAll() === true) && this.validatedSection === true) {
        this.$store.state.registrationInsuranceData = this.model
        return true
      } else {
        if (this.$validator.errors.length > 0) {
          document.getElementsByName(this.$validator.errors.items[0].field)[0].focus()
        }
        return false
      }
    }
  },
  computed: {
  },
  watch: {
    '$store.state.user': {
      handler: function (value) {
        let vue = this
        this.$store.state.calculations.map((calc) => {
          if (vue) {
            // eslint-disable-next-line no-eval
            eval(calc['code'])
          }
        })
      },
      deep: true
    }
  },
  beforeMount () {
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../assets/sass/paper/variables";
#select-payment{
  padding: 0px !important;
  line-height: 29px;
}

.margin{
  margin-top: 20px;
  margin-bottom: 10px;
}

>>> .el-select--large{
  width: 100%;
}

>>> .el-textarea__inner {
  border-color: #9A9A9A;
}

.el-select-dropdown__item {
  max-width: 100%;
  overflow: hidden;
  word-wrap: normal !important;
  word-break: break-word;
  white-space: pre-wrap;
  height: auto;
}

.general-inactive-section:focus-within {
  border-left-color: $primary-color !important;
}

@media (max-width: 400px) {
  .el-popper[x-placement^="top"] {
    left: 0px !important;
  }

  .el-popper[x-placement^="bottom"] {
    left: 0px !important;
  }
}

.display-block{
  display: block;
}

.display-inline{
  margin-left: 5px;
  display: inline;
}

.display-none{
  display: none;
}

.border-none{
  border: none;
}

.amount{
  font-weight: bold;
}

.mb-10{
  margin-bottom: 10px;
  font-weight: bold;
}

.checkbox-inline+.checkbox-inline, .radio-inline+.radio-inline {
  margin-left: 0;
}

.gender-float{
  text-align: left;
  padding: 0;
}

>>> .el-radio-button__inner {
  transition: none;
}

.mb-0{
  margin-bottom: 0;
}

.upload-file{
  width: 0;
  height: 0;
}

.upload-file-label{
  display: block;
  color: white;
  padding: 10px;
  text-align: center;
  border-radius: 6px;
  margin-top: 5px;
  margin-left: 35%;
  margin-right: 35%;
}
.green-border{
  border: 1px dashed $primary-color;
  background-color: #FCFCFC;
}
.cloud-image {
  width: 10%;
  height: 10%;
}
.elipsis{
  text-overflow: ellipsis;
  overflow: hidden;
  width: auto;
  height: 1.2em;
  white-space: nowrap;
}

@media screen and (max-width: 767px) {
  .gender-float{
    text-align: left;
    padding: 0;
  }
  .upload-file-label{
    display: block;
    color: white;
    padding: 5px;
    text-align: center;
    border-radius: 6px;
    margin-left: 20%;
    margin-right: 20%;
  }
}

@media screen and (max-width: 385px) {
  >>> .el-radio-button--small .el-radio-button__inner {
    padding: 9px 6px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/Sections/BillSection.vue